import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';
import React, { FC } from 'react';

import ArrowDown from '../images/arrow-down.svg';
import ArrowUp from '../images/arrow-up.svg';
import useStyles from './styles';

export interface NextPreviousButtonProps {
  className?: string;
  onNext: () => void;
  onNextDisabled?: boolean;
  onPrevious: () => void;
  onPreviousDisabled?: boolean;
}

export const NextPreviousButton: FC<NextPreviousButtonProps> = ({
  className,
  onNext,
  onNextDisabled,
  onPrevious,
  onPreviousDisabled,
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)}>
      <ButtonBase
        classes={{ disabled: classes.buttonDisabled }}
        className={classNames(classes.button, classes.previous)}
        disabled={onPreviousDisabled}
        onClick={onPrevious}
      >
        <img alt="previous applicant" src={ArrowUp} />
      </ButtonBase>
      <ButtonBase
        classes={{ disabled: classes.buttonDisabled }}
        className={classNames(classes.button, classes.next)}
        disabled={onNextDisabled}
        onClick={onNext}
      >
        <img alt="next applicant" src={ArrowDown} />
      </ButtonBase>
    </div>
  );
};

export default NextPreviousButton;
